// singleBriefSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

import axiosInstance from "../httpService/httpService";

export const fetchSingleBrief = createAsyncThunk(
  "singleBrief/fetchSingleBrief",
  async (id) => {
    const response = await axiosInstance.get(
      `/fetch-single-brief-admin/${id}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      }
    );
    return response.data;
  }
);

const singleBriefSlice = createSlice({
  name: "singleBrief",
  initialState: {
    brief: {},
    loading: false,
    error: null,
    isPlanAttached : false ,
    designlink : {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSingleBrief.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSingleBrief.fulfilled, (state, action) => {
        state.loading = false;
        state.brief = action.payload;
        state.isPlanAttached = action.payload.briefs?.is_Plan_attached === 'Y';        ;
        console.log("Action.payload : " + JSON.stringify(action.payload.briefs?.is_Plan_attached)) ;
        state.designlink = action.payload.briefs?.design_link ;        ;
      })
      .addCase(fetchSingleBrief.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default singleBriefSlice.reducer;
